const REBOOK_UPDATED = (state, Rebook) => {
  state.Rebook = Rebook
}

export default {
  REBOOK_UPDATED
}
